import React from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import resolveIcon, { isPhosphorIconSource } from '../components/icon/resolveIcon'
import '../css/TabsMui.css'

// TODO: Cuando termine la migración de GoogleIcon a Phosphor, quitar el
// fallback de string (GoogleIcon) en resolveIcon / tabs.icon.
const TabsMui = ({
  tabs = [],
  activeTab,
  onChange,
  iconSize = 20,
  filled = false,
  iconWeight = 'regular',
  inactiveColor,
  activeColor,
  scrollable = false,
  showDivider = true,
  marginBottom = 2,
  uppercaseLabels,
  appearance = 'standard',
  status,
  ariaLabel = 'Secciones'
}) => {
  const modern = appearance === 'modern'
  const pill = appearance === 'pill'
  const styledAppearance = modern || pill
  const resolvedInactiveColor = inactiveColor ?? (pill ? '#3f4a57' : '#7a7f87')
  const resolvedActiveColor = activeColor ?? (pill ? '#27588d' : '#4B6EA9')
  const inactiveIconColor = pill ? (inactiveColor ?? '#50739a') : 'inherit'
  const useUppercase = uppercaseLabels ?? !styledAppearance
  return (
    <Box
      className={
        modern ? 'app-tabs-header' : pill ? 'app-tabs-header app-tabs-header--pill' : undefined
      }
      sx={{
        ...(!styledAppearance ? { borderBottom: showDivider ? 1 : 0, borderColor: 'divider' } : {}),
        mb: marginBottom,
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        fontFamily: "var(--ubiqua-font, 'Geist', 'Inter', 'Segoe UI', sans-serif)"
      }}
    >
      <Tabs
        value={activeTab}
        onChange={(_, value) => onChange(value)}
        className={styledAppearance ? 'app-tabs-navigation' : 'oc-tabs-primary'}
        aria-label={ariaLabel}
        variant={scrollable ? 'scrollable' : 'standard'}
        scrollButtons={scrollable ? 'auto' : false}
        allowScrollButtonsMobile={scrollable}
        sx={{
          minWidth: 0,
          flex: '1 1 auto',
          '& .MuiTabs-indicator': {
            backgroundColor: pill ? '#e8f1fb' : resolvedActiveColor
          },
          '& .MuiTabs-scrollButtons.Mui-disabled': { opacity: 0.3 },
          ...(scrollable
            ? {
                '& .MuiTabScrollButton-root.Mui-disabled': {
                  display: 'none'
                }
              }
            : {})
        }}
      >
        {tabs.map((tab) => {
          const iconFilled = tab.filled ?? filled
          const weight = tab.iconWeight ?? (iconFilled ? 'fill' : iconWeight)
          const icon = resolveIcon({
            icon: tab.icon,
            iconNode: tab.iconNode,
            size: tab.iconSize || iconSize,
            weight,
            filled: iconFilled
          })
          return (
            <Tab
              key={tab.value}
              value={tab.value}
              label={useUppercase ? tab.label.toUpperCase() : tab.label}
              icon={icon && isPhosphorIconSource(tab) ? React.cloneElement(icon, { weight }) : icon}
              iconPosition="start"
              sx={{
                ...(!styledAppearance ? { minHeight: 48 } : {}),
                fontFamily: 'inherit',
                fontSize: 14,
                fontWeight: 500,
                textTransform: 'none',
                color: resolvedInactiveColor,
                '& .MuiTab-iconWrapper, & .material-symbols-outlined': {
                  color: inactiveIconColor
                },
                '&.Mui-selected': {
                  color: resolvedActiveColor,
                  fontWeight: 600,
                  '& .MuiTab-iconWrapper, & .material-symbols-outlined': {
                    color: 'inherit'
                  }
                },
                ...(scrollable ? { minWidth: 0, ...(!styledAppearance ? { px: 1.25 } : {}) } : {})
              }}
            />
          )
        })}
      </Tabs>
      {status != null && status !== false && (
        <Box className="app-tabs-status" role="status">
          {status}
        </Box>
      )}
    </Box>
  )
}

export default TabsMui